/**
 * @typedef {Object} outParam  - 出库参数
 * @property {string} businessItemId - 业务项目（坞修完工单项目、航修完工单项目，自修完工单项目，维护保养完工单项目）id
 * @property {string} businessType - 业务页面路由name
 * @property {string} itemType - 出库类型
 * @property {string} businessId - 业务id
 * @property {string} outId - 出库单id
 */
// 7-自由出库 3-维护保养消耗 4-自修消耗 5-航修消耗 6-坞修消耗
// 请注意，businessItemId必须是全局唯一的，否则会出现出库单id被覆盖的情况！！！
// 如果新增项目不存在唯一id，可以使用随机数或者时间戳代替
// ['', '', '','', 'self-repair-detail']
export default {
  state: {
    /**
     * 一个字符串的数组
     * @type {outParam[]}
     */
    outParams: [],
  },
  mutations: {
    emitOut(state, outParam) {
      state.outParams.push(outParam)
    },
    setOutId(state, outParam) {
      state.outParams = state.outParams.map((b) => {
        if (
          b.businessItemId === outParam.businessItemId &&
          b.itemType === outParam.itemType &&
          b.businessType === outParam.businessType
        ) {
          return { ...b, outId: outParam.outId }
        }
        return b
      })
    },
    removeOutParamById(state, businessId) {
      console.log(businessId)
      state.outParams = state.outParams.filter(
        (p) => p.businessId !== businessId,
      )
    },
    removeOutParamByItemId(state, businessItemId) {
      state.outParams = state.outParams.filter(
        (p) => p.businessItemId !== businessItemId,
      )
    },
    clearState(state) {
      state.outParams = []
    },
  },
}
